<div>
    <h5 class="text-start text-primary fw-bold ps-2 ms-1 mt-4">Enter OCI or PIO Card Details</h5>
    <div class="row mx-0 mt-5 pb-5">
        <div class="col-lg-6">
            <div class="form-floating mb-md-5 mb-4" >
                <select class="form-select" [ngClass]="docType ? '':'optionValue'"  [(ngModel)]="docType" id="docType" (change)="docError = false; checkType($event)">
                    <option *ngFor="let list of docTypeList; let i = index" [value]="list.DocumentTypeId">{{list.Name}}</option>
                    <!-- <option value="2">OCI Card</option>
                    <option value="3">PIO Card</option> -->
                </select>
                <label for="docType" [ngClass]="docType ? '':'form-select-label'">Document Type <span class="text-danger">*</span></label>
                <div class="text-danger small my-4" *ngIf="docError">
                    Please select document type
                </div>
            </div>
        </div>
        <!-- <div class="col-6">

        </div> -->
       
       
        
        <div class="col-lg-6">
            <form [formGroup]="OCIForm" novalidate>
                <!-- <div class="row mx-0"> -->
                    <!-- <div class="col-lg-6 col-12"> -->
                        <div class="form-floating ">
                            <input type="text" class="form-control text-uppercase" [ngClass]="OCIForm.controls.CardNo.value ? 'has-value' : ''" formControlName="CardNo" name="name" autocomplete="off" id="name" placeholder="Enter Card No" (paste)="(false)" appAlphanumeric>
                            <label for="name">Card No<span class="text-danger">*</span></label>
                            <div *ngIf="OCIForm.controls.CardNo.touched && OCIForm.controls.CardNo.errors" class="ms-3">
                                <!-- <span class="small text-danger">{{panNameMessage}}</span> -->
                            </div>
                        </div>
                    <!-- </div> -->
                    <!-- <div class="col-lg-6 col-12">
                        
                            <div class="form-floating  mb-md-5 mb-4">
                                <select class="form-select" [ngClass]="OCIForm.controls.Country.value ? 'has-value':'optionValue'" formControlName="Country" id="country" (change)="getCountryName()">
                                    <option [value]="list.Name" *ngFor="let list of countryList; let i = index">{{list.Name}}</option>
                                </select>
                                <label for="country" [ngClass]="OCIForm.controls.Country.value ? '':'form-select-label'">Select Country <span class="text-danger">*</span></label>
                            </div>
                    </div> -->
                  
                <!-- </div> -->
            </form>
        </div>
         <div class="col-lg-6 pe-md-5" *ngIf="docType === 1037">
            <div class="input-group border form-floating mb-4 rounded-2">
                <input class="form-control ms-0 my-1 border-0 pe-0 py-0" [(ngModel)]="lastArrivalDt" readonly placeholder="Enter Last Arrival in India" ngx-mydatepicker (click)="dp.toggleCalendar()" name="mydate"
                 [options]="options2" [defaultMonth]="defaultMonth.defMonth" id="pExpiry" #dp="ngx-mydatepicker" (dateChanged)="onDateArrival($event)" required/>
                <label for="pExpiry">Select Expiry Date<span class="text-danger">*</span></label>
                <span class="px-3 py-2">
                    <img src="./assets/images/Calendar.svg" (click)="dp.toggleCalendar()">
                </span>
            </div>
            <div *ngIf="arrivalDateError">
                <span class="small text-danger">Expiry Date should be above 60 days.</span>
            </div>
    </div>
    <ngx-ui-loader></ngx-ui-loader>
     <div class="col-lg-6">
            <div>
                <nri-app-img-upld [imageName]="'OCI/PIO or Resident Permit/Visa Front'" [docTypeID]="docType" (docTypeError)="typeError($event)" (getdocTypeID)="getID($event)" (imageURL)="imageURL($event)" #pioociimg [changeID]="changeIDs"></nri-app-img-upld>
                <div class="text-danger small mb-4" *ngIf="pioociImgempty">
                    Please upload your OCI or PIO image
                </div>
            </div>
        </div>
        <div class="col-lg-6">
            <div>
                <nri-app-img-upld [imageName]="'OCI/PIO or Resident Permit/Visa Back'" [docTypeID]="docType" 
                (docTypeError)="typeError($event)" (getdocTypeID)="getID($event)" (imageURL)="imageURL($event)" #pioocibackimg [changeID]="changeIDs"></nri-app-img-upld>
                <div class="text-danger small mb-4" *ngIf="pioocibackImgempty">
                    Please upload your OCI or PIO image
                </div>
            </div>
        </div>
         <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0">
            <div>
                <nri-app-img-upld [additionalImageName]="'Additional'" [imageName]="'PIOOCIAdd'"
                    [docTypeID]="docType" (getdocTypeID)="getID($event)"
                    (imageURL)="imageURL($event)" #foAdrimg [changeID]="changeIDs"></nri-app-img-upld>
            </div>
        </div>

    <div class="d-flex align-items-end mx-0 mt-5 pt-5 row">
        <div class="col-6 p-0">
            <button class="btn btn-white border-primary text-primary px-4" (click)="backStage()">Back</button>
        </div>
        <div class="col-6 text-end p-0 pe-md-3">
            <button class="btn btn-primary px-4" [disabled]="!pioociUpdt && OCIForm.invalid" (click)="stageValidate()">Next</button>
        </div>
    </div>
</div>
<app-error-modal #errorComp></app-error-modal>